import { useState } from 'react';
import { ImgStyled, Content } from './img.styled';

export const Img = (props) => {
  const { src, title, afterError, ...rest } = props;
  const [alt, setAlt] = useState(title);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onLoad = () => {
    setError(false);
    setLoading(false);
  };

  const onError = () => {
    // setAlt('Ошибка загрузки');
    setLoading(false);
    setError(true);
    if (afterError) {
      setTimeout(() => {
        setError(false);
        afterError();
      }, 10000);
    }
  };

  // let cl = className ?? '';
  const cl = 'img-block ' + (loading ? ' loading' : error ? ' error' : '');

  return (
    <Content className={cl}>
      <ImgStyled src={src} alt={alt} title={alt} onLoad={onLoad} onError={onError} {...rest} />
    </Content>
  );
};
